import {
  bezpecnyNazovInvestPdf,
  finalizujInvestPdfStrany,
  vytvorInvesticnyPdf,
  vytvorInvestPdfStav,
  zapisInvestPdfNadpis,
  zapisInvestPdfPrehlad,
  zapisInvestPdfRiadok,
  zapisInvestPdfUpozornenie,
} from "./investPdfPomocne";
import { zapisInvestPdfGrafy, } from "./investPdfGrafy";
import {
  zapisInvestPdfRentu,
  zapisInvestPdfScenare,
} from "./investPdfRozsireneMoznosti";
import {
  zapisInvestPdfOdporucania,
} from "./investPdfOdporucania";
import {
  zapisInvestPdfPoznamku,
  zapisInvestPdfVyvoj,
} from "./investPdfPoznamkyVyvoj";

const INVESTICNE_PDF_UPOZORNENIE =
  "Investovanie do finančných nástrojov je spojené s rizikom finančnej straty. " +
  "Doterajšie výnosy nie sú zárukou budúcich výnosov. " +
  "Hodnota investície môže rovnako rásť, ako aj klesať a nie je tak zaručená návratnosť pôvodne investovanej sumy. " +
  "S investíciou je spojené riziko, bližšie informácie o rizikách nájdete v štatúte a v KIID príslušného fondu. " +
  "Informácie uvedené v tomto materiály a porovnanie výnosnosti fondov a produktov zohľadňuje výnosnosť minulých období, nie je však zárukou budúcich výnosov. " +
  "Tieto informácie nie sú investičným prieskumom ani poskytnutím investičného poradenstva a nie sú ani návrhom na uzatvorenie obchodu zo strany FinCloud s.r.o.";

export async function exportInvesticnaPonukaPdf(
  dataPrePdf
) {
  const pdf =
    await vytvorInvesticnyPdf();

  const stav = vytvorInvestPdfStav(
    dataPrePdf?.kontaktPdf
  );

  const metadata =
    dataPrePdf?.metadata || {};

  const aktivneSekcie = Array.isArray(
    dataPrePdf?.aktivneSekcie
  )
    ? dataPrePdf.aktivneSekcie
    : [];

  pdf.setProperties({
    title:
      metadata.nazovDokumentu ||
      "Informatívna investičná ponuka",
    subject: aktivneSekcie.join(", "),
    author: "FinCloud s.r.o.",
  });

  zapisInvestPdfNadpis(
    pdf,
    stav,
    metadata.nazovDokumentu ||
      "Informatívna investičná ponuka"
  );

  if (metadata.menoKlienta) {
    zapisInvestPdfRiadok(
      pdf,
      stav,
      `Klient: ${metadata.menoKlienta}`
    );
  }

  zapisInvestPdfRiadok(
    pdf,
    stav,
    `Dátum vyhotovenia: ${
      metadata.datumVyhotovenia || ""
    }`
  );

  zapisInvestPdfPrehlad(
    pdf,
    stav,
    dataPrePdf
      ?.prehladInvesticie
  );

  zapisInvestPdfGrafy(
    pdf,
    stav,
    dataPrePdf?.grafy
    );

    zapisInvestPdfScenare(
        pdf,
        stav,
        dataPrePdf?.scenarePdf
        );

        zapisInvestPdfRentu(
        pdf,
        stav,
        dataPrePdf?.rentaPdf
        );

  zapisInvestPdfOdporucania(
    pdf,
    stav,
    dataPrePdf?.odporucaniaPdf
    );

    zapisInvestPdfPoznamku(
    pdf,
    stav,
    dataPrePdf?.poznamkaPdf
    );

    zapisInvestPdfVyvoj(
    pdf,
    stav,
    dataPrePdf
        ?.vyvojInvesticiePdf
    );

    zapisInvestPdfUpozornenie(
      pdf,
      stav,
      INVESTICNE_PDF_UPOZORNENIE,
      {
        zarovnatNadPatu: true,
      }
    );

  finalizujInvestPdfStrany(
    pdf,
    dataPrePdf?.kontaktPdf
  );

  pdf.save(
    bezpecnyNazovInvestPdf(
      metadata.nazovSuboru
    )
  );
}